import { render, staticRenderFns } from "./svcGroup.vue?vue&type=template&id=c4475f58&"
import script from "./svcGroup.vue?vue&type=script&lang=js&"
export * from "./svcGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4475f58')) {
      api.createRecord('c4475f58', component.options)
    } else {
      api.reload('c4475f58', component.options)
    }
    module.hot.accept("./svcGroup.vue?vue&type=template&id=c4475f58&", function () {
      api.rerender('c4475f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/svcManage/svcGroup/svcGroup.vue"
export default component.exports